export default __webpack_public_path__ + "static/media/sww.9f0b534f.png";